import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import {
  makeRequiredFieldsValidator,
  useFormState,
} from '../../../../hocs/useFormWithValidation';

export const initialState = {
  [PROFILE_FIELDS_TYPES.LOCATION]: null,
  [PROFILE_FIELDS_TYPES.REASON_TYPE_ID]: null,
  [PROFILE_FIELDS_TYPES.REASON_COMMENT]: null,
};

export const validateRequiredFields = makeRequiredFieldsValidator([
  PROFILE_FIELDS_TYPES.LOCATION,
  PROFILE_FIELDS_TYPES.REASON_TYPE_ID,
]);

export function useChangeStatusForm() {
  const { formState, handleFormChange } = useFormState(initialState);

  const isValid = validateRequiredFields(formState);

  return {
    isValid,
    formState,
    handleFormChange,
  };
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardTable/utils/useStatusInfoFormState.js